/* eslint-disable react/jsx-props-no-spreading */
import { LayoutProps, RankedTester, rankWith, uiTypeIs } from "@jsonforms/core";
import {
  JsonFormsDispatch,
  useJsonForms,
  withJsonFormsLayoutProps,
} from "@jsonforms/react";
import React from "react";
import "./css/Accordion.css";

// Context
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";

// Utils
import { useSelector } from "react-redux";
import { get } from "lodash";
import { evaluateContextRule, extractPath } from "../utils/commonUtils";

export const accordionRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("Accordion")
);

function AccordionRenderer({ schema, uischema, visible }: LayoutProps) {
  const { renderers, cells } = useJsonForms();

  const items = uischema.options?.items || [];

  const spectrumProps = uischema.options?.spectrumProps;
  const style = uischema.options?.style;
  const headingStyle = uischema.options?.headingStyle;
  const buttonStyle = uischema.options?.buttonStyle;
  const contentStyle = uischema.options?.contentStyle;
  const preExpanded = uischema.options?.preExpanded;

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    const reduxStateData = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxStateData
    )?.visible;
  }

  return (
    <Accordion
      preExpanded={preExpanded}
      allowZeroExpanded
      hidden={!componentVisibility}
      style={style}
      {...spectrumProps}
    >
      {items.map((item: any) => (
        <AccordionItem key={item.title} uuid={item.uuid}>
          <AccordionItemHeading style={headingStyle}>
            <AccordionItemButton style={buttonStyle}>
              {item.title}
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel style={contentStyle}>
            <JsonFormsDispatch
              renderers={renderers}
              cells={cells}
              uischema={item.children}
              schema={schema}
            />
          </AccordionItemPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
}

export default withJsonFormsLayoutProps(AccordionRenderer);
